import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Row, Col, Input, Label, FormGroup } from "reactstrap";
import BizinBackend from "../../../../helpers/bizin_helper";
import useGetCsrfToken from "../../../../Hooks/useGetCsrfToken";
import { useContext } from "react";
import { DF_OT0058Context } from "../context";
import { Checkbox } from "primereact/checkbox";
import TranspaleStringToComponente from "../../../../components/Dynamic/TranspaleStringToComponente";
import useGetHeightPage from "../../../../Hooks/useGetHeightPage";

const inputClassName = "rounded font-size-14 border-color-cinza2";

function GridBody() {
  const { userProfile, access_token } = useSelector((state) => ({
    userProfile: state.login.profile,
    access_token: state.login.user.access_token,
  }));

  const csrfToken = useGetCsrfToken();
  useGetHeightPage();

  const [deliveryTypes, setDeliveryTypes] = useState([]);
  const [preFilter, setPreFilter] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedVehicles, setSelectedVehicles] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [screenMode, setScreenMode] = useState("normal");
  const [formData, setFormData] = useState({
    descricao: "",
    quantidadeVolumeDiario: "",
    valorMercadoriaDiario: "",
    pesoBrutoDiario: "",
    quantidadeVeiculosDiario: "",
    quantidadeVolumeEntrega: "",
    valorMercadoriaEntrega: "",
    pesoBrutoEntrega: "",
    diasAntecedenciaAgendamento: "",
    unidadeAgendamento: "",
    dataEncerramento: "",
    limiteAgendamentosParceiro: "",
    tipoEntrega: "",
    permitirMesmoTipoEntrega: false,
  });

  const { navigate, location } = useContext(DF_OT0058Context);
  const searchParams = new URLSearchParams(location.search);

  const idEmpresa = searchParams.get("ID_Empresa");
  const idLocalEntrega = searchParams.get("ID_Local_Entrega");
  const idLocalDesembarque = searchParams.get("ID_Local_Desembarque");
  const handleInputChange = (e) => {
    const { id, value, type, checked } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [id]: type === "checkbox" ? checked : value,
    }));
  };

  const handleVehicleChange = (idVeiculo) => {
    setSelectedVehicles((prev) =>
      prev.includes(idVeiculo)
        ? prev.filter((id) => id !== idVeiculo)
        : [...prev, idVeiculo],
    );
  };

  const handleCategoryChange = (idCategoria) => {
    setSelectedCategories((prev) =>
      prev.includes(idCategoria)
        ? prev.filter((id) => id !== idCategoria)
        : [...prev, idCategoria],
    );
  };

  const handleSave = () => {
    setScreenMode("confirm");
  };

  const handleConfirm = async () => {
    try {
      const listaVeiculos =
        selectedVehicles.length > 0 ? selectedVehicles.join(",") : null;

      const listaCategorias =
        selectedCategories.length > 0 ? selectedCategories.join(",") : null;

      const payload = {
        1: Number(idLocalDesembarque),
        2: formData.descricao || null,
        3: formData.quantidadeVolumeDiario
          ? Number(formData.quantidadeVolumeDiario)
          : null,
        4: formData.valorMercadoriaDiario
          ? Number(formData.valorMercadoriaDiario)
          : null,
        5: formData.pesoBrutoDiario ? Number(formData.pesoBrutoDiario) : null,
        6: formData.quantidadeVeiculosDiario
          ? Number(formData.quantidadeVeiculosDiario)
          : null,
        7: formData.quantidadeVolumeEntrega
          ? Number(formData.quantidadeVolumeEntrega)
          : null,
        8: formData.valorMercadoriaEntrega
          ? Number(formData.valorMercadoriaEntrega)
          : null,
        9: formData.pesoBrutoEntrega ? Number(formData.pesoBrutoEntrega) : null,
        10: formData.diasAntecedenciaAgendamento
          ? Number(formData.diasAntecedenciaAgendamento)
          : null,
        11: formData.unidadeAgendamento
          ? Number(formData.unidadeAgendamento)
          : null,
        12: formData.tipoEntrega ? Number(formData.tipoEntrega) : null,
        13: formData.permitirMesmoTipoEntrega ? "S" : "N",
        14: formData.dataEncerramento || null,
        15: formData.limiteAgendamentosParceiro
          ? Number(formData.limiteAgendamentosParceiro)
          : null,
        16: listaVeiculos,
        17: listaCategorias,
        18: null, // ID_Log
        19: "N", // Mostra_Horario
      };

      const response = await BizinBackend.executeProcedure(
        payload,
        "SRM_Agendamento_Altera_Locais_Desembarque",
        csrfToken,
        access_token,
      );

      setScreenMode("success");
    } catch (error) {
      console.error("Erro ao alterar Local de Desembarque:", error);

      setScreenMode("error");
    }
  };
  const handleBack = () => {
    window.parent.postMessage(
      {
        type: "closeModal",
        isReloadPage: false,
      },
      "*",
    );
  };

  const formatDate = (value) => {
    if (!value) {
      return "";
    }

    return String(value).split("T")[0];
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        const [
          unloadingLocationResponse,
          deliveryTypesResponse,
          selectedVehiclesResponse,
          selectedCategoriesResponse,
        ] = await Promise.all([
          BizinBackend.executeProcedure(
            {
              1: idEmpresa,
              2: idLocalEntrega,
              3: idLocalDesembarque,
            },
            "FRONT_Agendamento_Obter_Lista_Locais_Desembarque",
            csrfToken,
            access_token,
          ),

          BizinBackend.executeProcedure(
            {
              1: idEmpresa,
            },
            "FRONT_Workspace_Lista_Tipo_Entrega",
            csrfToken,
            access_token,
          ),

          BizinBackend.executeProcedure(
            {
              1: idLocalDesembarque,
            },
            "FRONT_Workspace_DF_OT0055_Lista_Veiculos",
            csrfToken,
            access_token,
          ),
          BizinBackend.executeProcedure(
            {
              1: idEmpresa,
              2: idLocalDesembarque,
            },
            "FRONT_Workspace_DF_OT0055_Lista_Categorias",
            csrfToken,
            access_token,
          ),
        ]);

        const selectedVehicleIds = selectedVehiclesResponse
          .filter((vehicle) => vehicle.Disponivel === "X")
          .map((vehicle) => vehicle.ID_Veiculo);

        setSelectedVehicles(selectedVehicleIds);

        const selectedCategoryIds = selectedCategoriesResponse
          .filter((vehicle) => vehicle.Disponivel === "X")
          .map((vehicle) => vehicle.ID_Categoria);

        setSelectedCategories(selectedCategoryIds);

        if (Array.isArray(deliveryTypesResponse)) {
          setDeliveryTypes(deliveryTypesResponse);
        }

        if (Array.isArray(selectedVehiclesResponse)) {
          setVehicles(selectedVehiclesResponse);
        }

        if (Array.isArray(selectedCategoriesResponse)) {
          setCategories(selectedCategoriesResponse);
        }

        const unloadingLocation = Array.isArray(unloadingLocationResponse)
          ? unloadingLocationResponse[0]
          : unloadingLocationResponse;

        if (!unloadingLocation) {
          return;
        }

        setFormData({
          descricao: unloadingLocation.Descricao_Local_Desembarque ?? "",

          quantidadeVolumeDiario:
            unloadingLocation.Limite_Diario_Max_Volumes ?? "",

          valorMercadoriaDiario:
            unloadingLocation.Limite_Diario_Max_Valor ?? "",

          pesoBrutoDiario: unloadingLocation.Limite_Diario_Max_Peso ?? "",

          quantidadeVeiculosDiario:
            unloadingLocation.Limite_Diario_Max_Veiculos ?? "",

          quantidadeVolumeEntrega:
            unloadingLocation.Limite_Entrega_Max_Volumes ?? "",

          valorMercadoriaEntrega:
            unloadingLocation.Limite_Entrega_Max_Valor ?? "",

          pesoBrutoEntrega: unloadingLocation.Limite_Entrega_Max_Peso ?? "",

          diasAntecedenciaAgendamento:
            unloadingLocation.Limite_Max_Dias_Para_Agendar ?? "",

          unidadeAgendamento:
            unloadingLocation.Unidade_Agendamento_Minutos ?? "",

          dataEncerramento: formatDate(unloadingLocation.Data_Encerramento),

          limiteAgendamentosParceiro:
            unloadingLocation.Limite_Agendamentos_Diarios_Parceiro ?? "",

          tipoEntrega:
            unloadingLocation.ID_Tipo_Entrega ??
            unloadingLocation.Id_Tipo_Entrega ??
            "",

          permitirMesmoTipoEntrega:
            unloadingLocation.Permitir_Agendamento_Tipo_Entrega === "S",
        });
      } catch (error) {
        console.error("Error loading data:", error);
      }
    };

    if (
      csrfToken &&
      access_token &&
      idEmpresa &&
      idLocalEntrega &&
      idLocalDesembarque
    ) {
      loadData();
    }
  }, [csrfToken, access_token, idEmpresa, idLocalEntrega, idLocalDesembarque]);

  useEffect(() => {
    const filters = {};

    if (formData.dataEncerramento) {
      filters.Filtro_Data_Encerramento = {
        value: formData.dataEncerramento,
      };
    }

    if (Object.keys(filters).length > 0) {
      setPreFilter([filters]);
    }
  }, [formData.dataEncerramento]);

  return (
    <>
      {screenMode === "normal" && (
        <div className="form-default-primary df-ot0055-page p-0">
          <div className="mb-3">
            <Row className="gx-3 mb-0">
              <Col lg={4}>
                <FormGroup className="mb-3">
                  <Label for="descricao">Descrição</Label>
                  <Input
                    type="text"
                    id="descricao"
                    value={formData.descricao}
                    onChange={handleInputChange}
                    className={inputClassName}
                  />
                </FormGroup>
              </Col>

              <Col lg={4}>
                <FormGroup className="mb-3">
                  <Label for="quantidadeVolumeDiario">
                    Quantidade Volume Diário (Máx)
                  </Label>
                  <Input
                    type="number"
                    id="quantidadeVolumeDiario"
                    value={formData.quantidadeVolumeDiario}
                    onChange={handleInputChange}
                    className={inputClassName}
                  />
                </FormGroup>
              </Col>

              <Col lg={4}>
                <FormGroup className="mb-3">
                  <Label for="valorMercadoriaDiario">
                    Valor da Mercadoria Diário (Máx)
                  </Label>
                  <Input
                    type="number"
                    id="valorMercadoriaDiario"
                    value={formData.valorMercadoriaDiario}
                    onChange={handleInputChange}
                    className={inputClassName}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row className="gx-3 mb-0">
              <Col lg={4}>
                <FormGroup className="mb-3">
                  <Label for="pesoBrutoDiario">
                    Peso Bruto em KG Diário (Máx)
                  </Label>
                  <Input
                    type="number"
                    id="pesoBrutoDiario"
                    value={formData.pesoBrutoDiario}
                    onChange={handleInputChange}
                    className={inputClassName}
                  />
                </FormGroup>
              </Col>

              <Col lg={4}>
                <FormGroup className="mb-3">
                  <Label for="quantidadeVeiculosDiario">
                    Quantidade Veículos Diário (Máx)
                  </Label>
                  <Input
                    type="number"
                    id="quantidadeVeiculosDiario"
                    value={formData.quantidadeVeiculosDiario}
                    onChange={handleInputChange}
                    className={inputClassName}
                  />
                </FormGroup>
              </Col>

              <Col lg={4}>
                <FormGroup className="mb-3">
                  <Label for="quantidadeVolumeEntrega">
                    Quantidade Volume Por Entrega (Máx)
                  </Label>
                  <Input
                    type="number"
                    id="quantidadeVolumeEntrega"
                    value={formData.quantidadeVolumeEntrega}
                    onChange={handleInputChange}
                    className={inputClassName}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row className="gx-3 mb-0">
              <Col lg={4}>
                <FormGroup className="mb-3">
                  <Label for="valorMercadoriaEntrega">
                    Valor da Mercadoria Por Entrega (Máx)
                  </Label>
                  <Input
                    type="number"
                    id="valorMercadoriaEntrega"
                    value={formData.valorMercadoriaEntrega}
                    onChange={handleInputChange}
                    className={inputClassName}
                  />
                </FormGroup>
              </Col>

              <Col lg={4}>
                <FormGroup className="mb-3">
                  <Label for="pesoBrutoEntrega">
                    Peso Bruto em KG Por Entrega (Máx)
                  </Label>
                  <Input
                    type="number"
                    id="pesoBrutoEntrega"
                    value={formData.pesoBrutoEntrega}
                    onChange={handleInputChange}
                    className={inputClassName}
                  />
                </FormGroup>
              </Col>

              <Col lg={4}>
                <FormGroup className="mb-3">
                  <Label for="diasAntecedenciaAgendamento">
                    Dias de Antecedência para Agendamento
                  </Label>
                  <Input
                    type="number"
                    id="diasAntecedenciaAgendamento"
                    value={formData.diasAntecedenciaAgendamento}
                    onChange={handleInputChange}
                    className={inputClassName}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row className="gx-3 mb-0">
              <Col lg={4}>
                <FormGroup className="mb-3">
                  <Label for="unidadeAgendamento">
                    Und. para Agendamento em min.
                  </Label>
                  <Input
                    type="number"
                    id="unidadeAgendamento"
                    value={formData.unidadeAgendamento}
                    onChange={handleInputChange}
                    className={inputClassName}
                  />
                </FormGroup>
              </Col>

              <Col lg={4}>
                <FormGroup className="mb-3">
                  <TranspaleStringToComponente
                    elementId={"Data_Encerramento"}
                    elementProps={{
                      value: "",
                      type: "Date",
                      title: "Data de Encerramento",
                      id: "Filtro_Data_Encerramento",
                    }}
                    preFilter={preFilter}
                    onPreFilter={(filters) => {
                      setPreFilter((state) => [{ ...state[0], ...filters }]);

                      if (filters.Filtro_Data_Encerramento) {
                        setFormData((prev) => ({
                          ...prev,
                          dataEncerramento:
                            filters.Filtro_Data_Encerramento.value,
                        }));
                      }
                    }}
                  />
                </FormGroup>
              </Col>

              <Col lg={4}>
                <FormGroup className="mb-3">
                  <Label for="limiteAgendamentosParceiro">
                    Limite de Agendamentos Diários por Parceiro
                  </Label>
                  <Input
                    type="number"
                    id="limiteAgendamentosParceiro"
                    value={formData.limiteAgendamentosParceiro}
                    onChange={handleInputChange}
                    className={inputClassName}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row className="gx-3 mb-0 align-items-end">
              <Col lg={4}>
                <FormGroup className="mb-0">
                  <TranspaleStringToComponente
                    elementId={"ID_Tipo_Entrega"}
                    elementProps={{
                      value: formData.tipoEntrega,
                      type: "Combobox",
                      title: "Tipo de Entrega",
                      id: "Filtro_ID_Tipo_Entrega",
                      isDisabled: false,
                      procedure: "FRONT_Workspace_Lista_Tipo_Entrega",
                      procedureParams: [idEmpresa],
                    }}
                    preFilter={preFilter}
                    onPreFilter={(filters) => {
                      setPreFilter((state) => [{ ...state[0], ...filters }]);

                      if (filters.Filtro_ID_Tipo_Entrega) {
                        setFormData((prev) => ({
                          ...prev,
                          tipoEntrega: filters.Filtro_ID_Tipo_Entrega.value,
                        }));
                      }
                    }}
                  />
                </FormGroup>
              </Col>

              <Col lg={8}>
                <FormGroup className="mb-3">
                  <Label
                    htmlFor="permitirMesmoTipoEntrega"
                    className="d-flex align-items-center mb-0 font-size-13 text-muted"
                  >
                    <Checkbox
                      inputId="permitirMesmoTipoEntrega"
                      checked={formData.permitirMesmoTipoEntrega}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          permitirMesmoTipoEntrega: e.checked,
                        }))
                      }
                    />

                    <span className="ms-2">
                      Permitir Agendamentos para mesmo tipo de entrega
                    </span>
                  </Label>
                </FormGroup>
              </Col>
            </Row>
          </div>
          <Row className="gx-3 mt-0">
            <Col lg={6}>
              <div className="checkbox-container shadow-card">
                <h5 className="checkbox-container-title">
                  Selecione os Veículos
                </h5>

                <div className="checkbox-scroll">
                  {vehicles.map((veiculo) => (
                    <FormGroup key={veiculo.ID_Veiculo} className="mb-2">
                      <Label
                        htmlFor={`veiculo-${veiculo.ID_Veiculo}`}
                        className="d-flex align-items-center mb-0 font-size-12"
                      >
                        <Checkbox
                          inputId={`veiculo-${veiculo.ID_Veiculo}`}
                          checked={selectedVehicles.includes(
                            veiculo.ID_Veiculo,
                          )}
                          onChange={() =>
                            handleVehicleChange(veiculo.ID_Veiculo)
                          }
                        />

                        <span className="ms-2">
                          {veiculo.Descricao_Veiculo}
                        </span>
                      </Label>
                    </FormGroup>
                  ))}
                </div>
              </div>
            </Col>

            <Col lg={6}>
              <div className="checkbox-container shadow-card">
                <h5 className="checkbox-container-title">
                  Selecione as Categorias
                </h5>

                <div className="checkbox-scroll">
                  {categories.map((categoria) => (
                    <FormGroup key={categoria.ID_Categoria} className="mb-2">
                      <Label
                        htmlFor={`categoria-${categoria.ID_Categoria}`}
                        className="d-flex align-items-center mb-0 font-size-12"
                      >
                        <Checkbox
                          inputId={`categoria-${categoria.ID_Categoria}`}
                          checked={selectedCategories.includes(
                            categoria.ID_Categoria,
                          )}
                          onChange={() =>
                            handleCategoryChange(categoria.ID_Categoria)
                          }
                        />

                        <span className="ms-2">{categoria.Descricao}</span>
                      </Label>
                    </FormGroup>
                  ))}
                </div>
              </div>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col
              lg={12}
              className="d-flex justify-content-end align-items-center"
            >
              <button
                type="button"
                className="btn fw-semibold btn-confirmar-co0005"
                onClick={handleSave}
              >
                Gravar
              </button>
            </Col>
          </Row>
        </div>
      )}

      {screenMode === "confirm" && (
        <div
          className="d-flex flex-column justify-content-center align-items-center text-center"
          style={{ padding: "40px 24px" }}
        >
          <div className="icon-warning">
            <i className="fas fa-exclamation-triangle"></i>
          </div>

          <h5 className="modal-title-custom">
            Deseja alterar as informações
            <br />
            do Local de Desembarque?
          </h5>

          <p className="modal-subtext">
            Ao clicar em "Confirmar" o Local de Desembarque
            <br />
            será alterado.
          </p>

          <div className="modal-actions">
            <button
              className="btn fw-semibold btn-cancelar-co0005"
              onClick={() => setScreenMode("normal")}
            >
              Cancelar
            </button>

            <button
              className="btn fw-semibold btn-confirmar-co0005"
              onClick={handleConfirm}
            >
              Confirmar
            </button>
          </div>
        </div>
      )}

      {screenMode === "success" && (
        <div
          className="d-flex flex-column justify-content-center align-items-center text-center"
          style={{ padding: "40px 24px" }}
        >
          <div className="icon-success">
            <i className="fas fa-check"></i>
          </div>

          <h5 className="modal-title-custom">Sucesso!</h5>

          <p className="modal-subtext">
            Local de Desembarque alterado com sucesso!
          </p>

          <button
            className="btn fw-semibold btn-confirmar-co0005"
            onClick={handleBack}
          >
            Ok!
          </button>
        </div>
      )}

      {screenMode === "error" && (
        <div
          className="d-flex flex-column justify-content-center align-items-center text-center"
          style={{ padding: "40px 24px" }}
        >
          <div className="icon-error">
            <i className="fas fa-times"></i>
          </div>

          <h5 className="modal-title-custom mb-3">Ops!</h5>

          <p className="modal-subtext">
            Não foi possível alterar o Local de Desembarque.
          </p>

          <button
            className="btn fw-semibold btn-confirmar-co0005"
            onClick={() => setScreenMode("normal")}
          >
            Ok!
          </button>
        </div>
      )}
    </>
  );
}

export default GridBody;
